import { useState } from "react";
import { Link } from "react-router-dom";
import { Smartphone, X } from "lucide-react";
import { useAuth } from "@/context/AuthContext";

const KEY = "lux_app_banner_dismissed";

export const AppBanner = () => {
  const { user } = useAuth();
  const [hidden, setHidden] = useState(() => localStorage.getItem(KEY) === "1");
  const eligible = user?.role === "customer" || (user?.role === "driver" && user?.driver_status === "approved");
  if (!eligible || hidden) return null;
  return (
    <div data-testid="app-banner" className="mb-6 flex items-center gap-3 rounded-xl border border-amber-400/25 bg-amber-400/[0.06] px-4 py-3 text-sm">
      <Smartphone className="h-5 w-5 shrink-0 text-amber-400" />
      <p className="mr-auto text-amber-100">The Luxury Rideshare phone app is here.</p>
      <Link to="/get-the-app" data-testid="app-banner-link" className="whitespace-nowrap font-medium text-amber-300 hover:text-amber-200">Get the App</Link>
      <button data-testid="app-banner-dismiss" onClick={() => { localStorage.setItem(KEY, "1"); setHidden(true); }} className="p-1 text-zinc-500 hover:text-zinc-300" aria-label="Dismiss"><X className="h-4 w-4" /></button>
    </div>
  );
};
